import script from "./phoneVerifyDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./phoneVerifyDialog.vue?vue&type=script&setup=true&lang=js"

import "./phoneVerifyDialog.vue?vue&type=style&index=0&id=98fe1924&lang=scss&scoped=true"
import "./phoneVerifyDialog.vue?vue&type=style&index=1&id=98fe1924&lang=scss"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98fe1924"]])

export default __exports__